<div
  class="programs-list"
  [loadMore]="programList?.pagination?.loadMore"
  [isLoadingMore]="programList.pagination.isLoadingMore"
  (medInfiniteScroll)="getProgramsList()"
>
  <mec-programs-item
    [program]="program"
    *ngFor="let program of programList.programs"
  ></mec-programs-item>
  @if(isLoading || programList?.pagination?.isLoadingMore) {
  <!-- Loader Skeleton start -->
  <ng-container>
    <div
      *ngFor="let item of [0, 1, 2]"
      [medSkeletonLoading]="true"
      style="height: auto; width: 100%; min-height: 200px"
    ></div>
    <!-- Loader Skeleton end -->
  </ng-container>
  } @if(!isLoading && !programList.programs.length) {
  <h5>
    {{ 'NO_RESULTS_FOUND' | translate }}
  </h5>
  }
</div>
